/* eslint-disable */
// Custom-styled dropdowns for the <select> fields in the MSPC Multi-Field Search panel
// (mspcCollapseFields), replacing the native OS/browser select widget with Choices.js.
// Styling for the rendered markup lives in _search.scss under .mspc-field-choices.
import Choices from 'choices.js';

// Keyed by the underlying <select> element, not its id, since a couple of ids are only
// unique within their own scope's field-set.
const instances = new Map();

function createChoices(select) {
    if (instances.has(select)) {
        return instances.get(select);
    }

    const choices = new Choices(select, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: '',
        allowHTML: false,
        placeholder: true,
        classNames: {
            containerOuter: ['choices', 'mspc-field-choices'],
        },
    });

    instances.set(select, choices);
    return choices;
}

function initMspcSelects() {
    document.querySelectorAll('.mspc-field-grid select.form-control').forEach((select) => {
        createChoices(select);
    });
}

// Called from results.twig's loadMspcFieldOptions() after it adds freshly-fetched
// <option>s to a select - rebuilds that select's Choices instance from the select's
// current option list so the custom dropdown reflects them too.
function refreshMspcSelect(select) {
    const choices = instances.get(select);
    if (!choices) {
        return;
    }

    const options = Array.from(select.options).map((option) => ({
        value: option.value,
        label: option.textContent,
        selected: option.selected,
        // Without this, Choices still carries the placeholder choice it detected at init
        // time (from the same empty-value <option>) alongside this one, rendering it twice.
        placeholder: option.value === '',
    }));

    choices.clearStore();
    choices.setChoices(options, 'value', 'label', true);
}

$(document).ready(initMspcSelects);

window.MspcFieldSelect = { refresh: refreshMspcSelect };
